import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '../../Button/Button';
import './Welcome.css';
import { useMediaQuery } from 'react-responsive';
import Drawer from '@material-ui/core/Drawer/Drawer';

const WelcomeCalendar: React.FC = props => {
	const [show, setShow] = React.useState(true);
	const isMobile = useMediaQuery({ maxWidth: 600 });

	const isOpened = localStorage.getItem("welcomeCalendar");

	const setClose = () => {
		localStorage.setItem("welcomeCalendar", "1");
		setShow(false);
	};

	const content = () => {
		return (
			<div className="welcome-calendar__wrapper">
				<div className="welcome-calendar__icon" />

				<div className="welcome-calendar__header">Книги по датам</div>

				<div className="welcome-calendar__content">
					Указывайте даты при добавлении книг в библиотеку, или добавляйте к ним
					историю прочтений, чтобы книги из вашей библиотеки отобразились в этом
					разделе
				</div>

				<Button className="welcome-calendar__button" type="primary" onClick={setClose}>
					Понятно
				</Button>
			</div>
		);
	};

	return !isMobile ? <Dialog open={isOpened !== "1" && show} onClose={setClose}>
		{content()}
	</Dialog> : <Drawer anchor="bottom" open={isOpened !== '1' && show} onClose={setClose}>
			{content()}
	</Drawer>
};

export default WelcomeCalendar;
